import React from 'react';
import clsx from 'clsx';

const MemberDashboardGridItem = React.forwardRef(function MemberDashboardGridItem(
  {
    className,
    style,
    children,
    content,
    bodyClassName,
    bodyRef,
    ...rest
  },
  ref
) {
  return (
    <div
      ref={ref}
      className={clsx('member-dashboard__grid-item', className)}
      style={style}
      {...rest}
    >
      <div
        ref={bodyRef}
        className={clsx('member-dashboard__grid-item-body', bodyClassName)}
      >
        {content}
      </div>
      {children}
    </div>
  );
});

export default MemberDashboardGridItem;
